__turbopack_context__.v({
  "button": "TweetIntentButton-module__VoMQ4G__button",
  "icon": "TweetIntentButton-module__VoMQ4G__icon",
  "root": "TweetIntentButton-module__VoMQ4G__root",
});
